/** Inicialización opcional de Sentry en el frontend (REACT_APP_SENTRY_DSN). */

export function initSentry() {
  const dsn = (process.env.REACT_APP_SENTRY_DSN || '').trim();
  if (!dsn) return false;

  try {
    // eslint-disable-next-line global-require
    const Sentry = require('@sentry/react');
    Sentry.init({
      dsn,
      environment:
        (process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || 'development').trim() ||
        'development',
      release: (process.env.REACT_APP_SENTRY_RELEASE || '').trim() || undefined,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0.1),
      sendDefaultPii: false,
    });
    return true;
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[sentry] init skipped:', error?.message || error);
    }
    return false;
  }
}
